const swimMen = [
  { title: "Trunks", icon: "icon1", subcategories: [] },
  { title: "Board Shorts", icon: "icon2", subcategories: [] },
  { title: "Brief/Speedo", icon: "icon2", subcategories: [] },
];
export default swimMen;
